export default "__VITE_ASSET__33vZ5ilT__"